export enum MediaFileTypes {
  TRACK = 0,
  PROMO = 1,
  VIDEO = 5,
  IMAGE = 6,
  VIDEO_PROMO = 8,
  IMAGE_PROMO = 9,
}

export const VIDEO_MEDIA_ACCEPT = {
  'video/mp4': ['.mp4'],
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
};

// Backend ingress limits the multipart request to 500m; transport errors still remain authoritative.
export const MAX_VIDEO_MEDIAFILE_SIZE = 500 * 1024 * 1024;
